(ns storrito.video.config)

;; The bare minimum of Instagram story videos is 0.1s
;; A minimum of 0.5s seems to be a good duration to prevent the servers from
;; converting too many very small videos. Also the video cut gui works better with
;; longer durations. (time handles etc.)

(def ig-story-min-duration
  ;; A story video item should be at least
  1.0
  ;; second long.
  )

(def ig-story-max-duration
  ;; A story video item should be
  60.0
  ;; seconds long.
  )

(def ig-image-gif-duration
  ;; A story image with a GIF should be
  15.0
  ;; seconds long.
  )

(def max-items
  ;; Split a video into maximum of
  2
  ;; items, each not longer than `ig-story-max-duration`.

  ;; 2023-01-05: The `max-items` value is low to reduce the amount of
  ;; traffic we need to send via the BrightData proxies. For new
  ;; connections we switched completely to TheSocialProxy.com around 2
  ;; months ago, where we have unlimited traffic. However, a few
  ;; customers are still on the BrightData residential proxies, where
  ;; we pay $16 per GB. This is still a huge cost driver. For December
  ;; 2022 the total costs for BrightData were still higher than the
  ;; one for TheSocialProxy, despite the fact that only a majority of
  ;; the customers use BrightData.
  )

(def max-duration
  ;; The maximum video duration that Storrito support to auto-split
  ;; and post as Instagram Stories:
  (* max-items
     ig-story-max-duration)
  ;; in seconds.
  )

(def max-duration-in-minutes
  (/ max-duration
     60.0))

#?(:cljs
   (defn ^:export set-max-duration
     "Allows to increase the duration to deploy the video auto
      splitting as hidden feature."
     [duration]
     (set! max-duration
           duration))
   )

(def rendering-max-duration
  (max
    max-duration
    (* max-items
       ig-story-max-duration)))

(def rendering-timeout
  ;; Stop the rendering of a video part (parallel rendering) if it
  ;; takes longer than
  (* rendering-max-duration
     4)
  ;; seconds.
  )
